exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-input__icon[data-v-b1c8f218]{width:11px!important;min-width:11px!important}", ""]);

// exports
